import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { NavLink, withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { loadLocationWithMessage } from '../../../actions/location'
import '../../../styles/assets/css/pages/patient_contract.css'

import Button from '@material-ui/core/Button'
import '../../../styles/assets/css/pages/additional_program.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import EditIcon from '@material-ui/icons/Edit'
import Pagination from '../../functions/pagination'
import { progress } from '../../admin/variables/patient_contract'

class CoachingMaterialList extends Component {
  constructor(props) {
      super(props);
      this.state = {
        efc: -1,
        appt1: 0,
        appt2: 0,
        appt3: 0,
        appt4: 0,
        appt5: 0,
      }
  }

  componentDidMount() {
    this.getDataList()
  }

  getAvailableDays = (apptDate) => {
    if (!apptDate) return 0

    // Use local calendar dates to avoid UTC timezone issues
    const dateStr = String(apptDate).substring(0, 10)
    const parts = dateStr.split('-').map(Number)

    if (parts.length !== 3 || parts.some(n => !Number.isFinite(n))) {
      return 0
    }

    const [year, month, day] = parts
    const appt = new Date(year, month - 1, day)

    if (
      appt.getFullYear() !== year ||
      appt.getMonth() !== month - 1 ||
      appt.getDate() !== day
    ) return 0

    const today = new Date()

    const apptDay = Date.UTC(year, month - 1, day)
    const todayDay = Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    )

    const daysPassed = Math.floor(
      (todayDay - apptDay) / (1000 * 60 * 60 * 24)
    )

    return Math.max(0, Math.min(daysPassed, 6))
  }

  getDataList = () => {
    axios({
      method: 'post',
      url: connectNode + 'patient/additional_program/check_consent_status_appt',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.authReducer.uid,
        consent_id: 1,
        appt_reason: 132,
      }
    })
    .then((result) => {
      const consent = result.data?.[0]?.consent === 1

      if(consent == 1) {
        this.setState({
          efc: consent ? 1 : 0,
          appt1: consent ? (result.data?.[1]?.[0]?.appt_date ?? null) : null,
          appt2: consent ? (result.data?.[1]?.[1]?.appt_date ?? null) : null,
          appt3: consent ? (result.data?.[1]?.[2]?.appt_date ?? null) : null,
          appt4: consent ? (result.data?.[1]?.[3]?.appt_date ?? null) : null,
          appt5: consent ? (result.data?.[1]?.[4]?.appt_date ?? null) : null,
        })
      } else {
        this.props.onLoadLocation('/dashboard')
        this.props.history.push('/dashboard')
      }
    })
  }



  render() {
    const module1Days = this.getAvailableDays(this.state.appt1)
    const module2Days = this.getAvailableDays(this.state.appt2)
    const module3Days = this.getAvailableDays(this.state.appt3)
    const module4Days = this.getAvailableDays(this.state.appt4)
    const module5Days = this.getAvailableDays(this.state.appt5)

    return (
    <div className="box_border4">
      <div className="row">
        <div className="small-12 columns headerPage1">
          Executive Function Coaching
        </div>
      </div>
      <div className="row">
        <div className="small-12 columns headerPage4">
          Summary Sheets
        </div>
      </div>
      <div className="row">
        <div className="small-12 columns ">
          <div>
            <table className="table_data1">
              <thead className="table_head">
                <tr>
                  <th>Meterial</th>
                  <th>File</th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td>Module 1: Understanding Executive Functioning and Bipolar Disorder</td>
                <td><a target="_blank"
                href='/pdf/Executive_Functioning_Coaching/Module1_Understanding_Executive_Functioning_and_Bipolar_Disorder-Summary.pdf' >PDF</a></td>
              </tr>
              <tr>
                <td>Module 2: Pause and Orient</td>
                <td><a target="_blank"
                href='/pdf/Executive_Functioning_Coaching/Module2_Pause_and_Orient-Summary.pdf' >PDF</a></td>
              </tr>
              <tr>
                <td>Module 3: Clarify Priorities</td>
                <td><a target="_blank"
                href='/pdf/Executive_Functioning_Coaching/Module3_Clarify_Priorities-Summary.pdf' >PDF</a></td>
              </tr>
              <tr>
                <td>Module 4: Plan and Sequence</td>
                <td><a target="_blank"
                href='/pdf/Executive_Functioning_Coaching/Module4_Plan_and_Sequence-Summary.pdf' >PDF</a></td>
              </tr>
              <tr>
                <td>Module 5: Monitor and Adjust</td>
                <td><a target="_blank"
                href='/pdf/Executive_Functioning_Coaching/Module5_Monitor_and_Adjust-Summary.pdf' >PDF</a></td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="small-12 columns headerPage4">
          Homeworks
        </div>
      </div>
      { typeof this.props.locationReducer.txt_message !== 'undefined' &&
        this.props.locationReducer.txt_message !== "" &&
        <div className="row warning_msg7">
          <div className="small-12 columns ">
            <div className="float_left1"><CheckCircleOutlineIcon /></div>
            <div className="txt_warning_msg1">{ this.props.locationReducer.txt_message }</div>
          </div>
        </div>}
      <div className="row homework_list">
        <div className="small-12 columns">

          {module1Days > 0 &&
          <div className="row small-12 columns mod_1">
            <div className="small-12 columns topic1">
              Module 1: Understanding Executive Functioning and Bipolar Disorder
            </div>
            <div className="small-12 columns">
              {Array.from({ length: module1Days }, (_, i) => (
                <div
                  className="small-6 medium-2 columns float_left"
                  key={'module1_day' + (i + 1)}
                >
                  <EditIcon />{' '}
                  <a href={'/member/additional_program/homework_efc/module1/' + (i + 1)}>
                    Day {i + 1}
                  </a>
                </div>
              ))}
            </div>
          </div>}

          {module2Days > 0 &&
          <div className="row small-12 columns mod_1">
            <div className="small-12 columns topic1">
              Module 2: Pause and Orient
            </div>
            <div className="small-12 columns">
              {Array.from({ length: module2Days }, (_, i) => (
                <div
                  className="small-6 medium-2 columns float_left"
                  key={'module2_day' + (i + 1)}
                >
                  <EditIcon />{' '}
                  <a href={'/member/additional_program/homework_efc/module2/' + (i + 1)}>
                    Day {i + 1}
                  </a>
                </div>
              ))}
            </div>
          </div>}

        </div>
      </div>
    </div>
  )}
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CoachingMaterialList)
